<script setup lang="ts">
import { PhCheckCircle, PhLock, PhPackage, PhPi } from '@phosphor-icons/vue'

defineOptions({ name: 'EscrowPreviewCard' })

// An illustration of one order going through escrow, beside the Home hero.
// Made-up data on purpose: it shows how getting paid works, not a real order.

const steps = [
  { icon: PhLock, iconClass: 'text-accent-cyan', title: 'Paid into escrow', detail: 'Pi is held safely' },
  { icon: PhPackage, iconClass: 'text-accent-purple', title: 'Work delivered', detail: 'Through the order chat' },
  { icon: PhCheckCircle, iconClass: 'text-accent-green', title: 'Released to seller', detail: 'Just now' },
]
</script>

<template>
  <div class="relative w-80 rotate-2" aria-hidden="true">
    <div
      class="absolute -bottom-5 -right-6 z-10 flex -rotate-3 items-center gap-2 rounded-xl border border-line bg-surface-2 px-3 py-2 shadow-lg"
    >
      <PhCheckCircle class="h-5 w-5 text-accent-green" weight="fill" />
      <div class="leading-tight">
        <p class="text-[11px] text-ink-5">Payment released</p>
        <p class="text-sm font-bold text-accent-green">+25 π</p>
      </div>
    </div>

    <div class="rounded-3xl border border-line bg-surface/80 p-5 shadow-xl backdrop-blur-md">
      <div class="mb-4 flex items-center gap-3">
        <span
          class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-linear-to-tr from-cyan-400 to-purple-500 text-sm font-bold text-on-accent"
        >
          M
        </span>
        <div class="min-w-0">
          <p class="truncate font-semibold text-ink">Logo for a coffee roaster</p>
          <p class="text-xs text-ink-5">by mira_makes</p>
        </div>
      </div>

      <div class="mb-5 flex items-center justify-between rounded-2xl bg-surface-2 px-4 py-3">
        <span class="text-sm text-ink-5">Order total</span>
        <span class="flex items-center gap-1 text-lg font-bold text-ink">
          <PhPi class="h-5 w-5 text-accent-amber" />
          25.00
        </span>
      </div>

      <ol class="space-y-4">
        <li v-for="(step, i) in steps" :key="step.title" class="relative flex items-start gap-3">
          <!-- The line linking each step to the next. -->
          <span
            v-if="i < steps.length - 1"
            class="absolute left-4 top-8 h-4 w-px -translate-x-1/2 bg-line-3"
          />
          <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-surface-2">
            <component :is="step.icon" class="h-4 w-4" :class="step.iconClass" weight="bold" />
          </span>
          <div class="leading-tight">
            <p class="text-sm font-semibold text-ink">{{ step.title }}</p>
            <p class="text-xs text-ink-5">{{ step.detail }}</p>
          </div>
        </li>
      </ol>
    </div>
  </div>
</template>
